module.exports = __webpack_public_path__ + "img/banner4.e02272c2.png";